import type { FaireProductEntity } from "../../entity_types/product";

export const p_77tzd3hqfq: FaireProductEntity = {
  token: "p_77tzd3hqfq",
  type: "product",
  name: "Hand-Carved Sea Jasper Cat Gemstone Animal Carving",
  brandToken: "b_yv36hmng6n",
  brandName: "Gem Avenue Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/1a5e8559e69f9be58e957d5c4c1a904609e84fb2f7ab09b3a01ec11d607f273c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/65a01a8b5dee0d50abef9f9a5629eb165cacf336239e1a0121942504b1d1e4f4.jpeg",
    "https://cdn.faire.com/fastly/bd26afba45cfabe9674be62f4c4ea356858a7d92a43d804c985aaac082e44c4a.jpeg",
    "https://cdn.faire.com/fastly/3876144372836379a7d1956957337d83fb54ceadfb681ed33c80377e4aa1a40a.jpeg",
    "https://cdn.faire.com/fastly/1ae95eadfc65c70cc5f17e10b4b2dde75cdc7d2e36f181f57767e11b1a8d7c1d.jpeg",
    "https://cdn.faire.com/fastly/c1984aced2ab3faf62b5ea58a01131b457b0e3293f003d3f3e9995abf3b5b49d.jpeg",
    "https://cdn.faire.com/fastly/c315ed92dcd901542810111466e11f84937de2140033f83d738c2b7e414413de.jpeg",
    "https://cdn.faire.com/fastly/03325d9508236b168cd6b58b419129527602b77feb96f7165310be709ffb55f9.jpeg",
    "https://cdn.faire.com/fastly/1dc1c8f1e21a07f761e4ce5f38a7d80ee7063a43218f0ac07c73e021c184648e.jpeg",
  ],
  priceDollars: 9.98,
  description:
    "This hand-carved sea jasper cat gemstone animal carving is a natural and unique addition to any collection. Each turtle figurine is expertly crafted from high-quality gemstones and imported from China. Perfect for retailers looking to make a good profit with the lowest wholesale prices.\n",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:23.824Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
